import type { FaireProductEntity } from "../../entity_types/product";

export const p_jmdw6d67yx: FaireProductEntity = {
  token: "p_jmdw6d67yx",
  type: "product",
  name: "celebrate sticker sheets",
  brandToken: "b_mmdanrh9jf",
  brandName: "emily lex studio",
  imageUrl:
    "https://cdn.faire.com/fastly/4d5b0cc416301ac7e2ff28d85ffb477e3828cd3d7e6314e0b185293534bca3b5.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ddcbb3537a20899e88e21fc652c8cb1773c440ba2d3013ffd1eb73923f19f94c.jpeg",
    "https://cdn.faire.com/fastly/742a198aed44d1f42acd0836ff19a51b8b8fe33b83aa4ba86548811d7c23a88a.jpeg",
  ],
  priceDollars: 4,
  description:
    'These two sticker sheets are filled with celebration illustrations — cakes, balloons, party hats, streamers, and more — made to be scattered wherever you want a small moment of delight.\n\nAdd them to envelopes, journals, gift tags, water bottles, planners, or anywhere that could use a little color.\n\nDetails:\n- 2 sticker sheets\n- 5" x 7" sheets\n- Matte laminated vinyl\n- Original watercolor artwork by Emily Lex\n\n\n',
  tags: [],
  msrpDollars: 8,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-14T07:15:08.822Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
